import { createColumnHelper } from '@tanstack/react-table'
import { UserGroupMember } from '../../types/GroupTypes'

export const memberGroupColumns = () => {
  const columnHelper = createColumnHelper<UserGroupMember>()

  const columnHelpers = [
    columnHelper.accessor('name', {
      header: 'Members',
    }),
    columnHelper.accessor('email', {
      header: 'Email',
    }),
    columnHelper.accessor('activeDeviceCount', {
      header: 'Active Devices',
    }),
    columnHelper.accessor('pendingDeviceCount', {
      header: 'Pending Devices',
    }),
    columnHelper.accessor('groupCount', {
      header: 'Groups',
    }),
  ]

  return columnHelpers
}
